import { memo, useLayoutEffect, useState } from 'react'
import { AnimatedSwitch, RouterPanel, usePanelHistoryTop } from 'weblite-router'
import { VisibilityHandler } from './components/visibility-handler'
import {
  WorkbenchPanel,
  GeneralIssuePanel,
  VitrinePanel,
  RoomListPanel,
} from './router-panels'
import { NativeColors, useSetNativeColors } from '$logic/native-colors'

const panelsIndex = {
  roomList: 0,
  'general-issue': 1,
  workbench: 2,
  vitrine: 3,
}

export const homePanelAPI = {
  setNativeColors(_colors: NativeColors) {},
}

export const Home = memo(function Home() {
  const { tab } = usePanelHistoryTop()?.state || {}
  const [overriddenNativeColors, setOverriddenNativeColors] =
    useState<NativeColors>({})

  useLayoutEffect(() => {
    homePanelAPI.setNativeColors = (newColors: NativeColors) =>
      setOverriddenNativeColors(colors => ({
        statusBar: newColors.statusBar || colors.statusBar,
        bottomSafeArea: newColors.bottomSafeArea || colors.bottomSafeArea,
      }))
  }, [])

  useSetNativeColors(
    () => ({
      statusBar: overriddenNativeColors?.statusBar || 'default',
      bottomSafeArea: overriddenNativeColors?.bottomSafeArea || 'default',
    }),
    [tab, overriddenNativeColors],
    tab !== 'roomList',
  )

  return (
    <VisibilityHandler
      zIndex={1}
      considerIOSNotch
      style={{ transform: 'translate3d(0)' }} // NOTE: Do NOT remove this line
    >
      <AnimatedSwitch
        name="slide"
        activeKey={panelsIndex[tab as keyof typeof panelsIndex] || 0}
        keepAllMounted
      >
        <RoomListPanel.Portal>
          <RouterPanel />
        </RoomListPanel.Portal>

        <GeneralIssuePanel.Portal>
          <RouterPanel />
        </GeneralIssuePanel.Portal>

        <WorkbenchPanel.Portal>
          <RouterPanel />
        </WorkbenchPanel.Portal>

        <VitrinePanel.Portal>
          <RouterPanel />
        </VitrinePanel.Portal>
      </AnimatedSwitch>
    </VisibilityHandler>
  )
})
